import { Card, Col, Row, Skeleton, Typography } from "antd"
import { faArrowUpRightFromSquare } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import moment from "moment"
import { ProposalSummary, formatDaysInReview } from "./proposalsModel"

type Props = {
  summary?: ProposalSummary
  loading: boolean
  jobLink?: string
}

const formatDate = (value: string | undefined) => {
  if (value === undefined || value === null || value === '') {
    return '—'
  }
  return moment.utc(value).local().format("MMMM D, YYYY")
}

const SummaryField = ({ label, value }: { label: string, value: string }) => {
  return <div style={{ marginBottom: '16px' }}>
    <Typography.Text type="secondary" style={{ display: 'block', fontSize: '12px' }}>{label}</Typography.Text>
    <Typography.Text strong>{value}</Typography.Text>
  </div>
}

const ProposalSummaryCard = ({ summary, loading, jobLink }: Props) => {
  if (loading) {
    return <Card style={{ marginBottom: '16px' }}><Skeleton active paragraph={{ rows: 3 }} /></Card>
  }
  if (summary === undefined) {
    return null
  }

  return <Card title="Proposal Summary" size="small" style={{ marginBottom: '16px' }}>
    <Row>
      <Col xs={24} md={12}>
        <SummaryField label="First Created" value={formatDate(summary.firstCreatedUtc)} />
        <SummaryField label="First Sent" value={formatDate(summary.firstSentUtc)} />
        <SummaryField label="Total Time in Review" value={formatDaysInReview(summary.daysInReview) ?? '—'} />
        {jobLink !== undefined && <a href={jobLink}>
          Go to Job <FontAwesomeIcon icon={faArrowUpRightFromSquare} style={{ marginLeft: '4px', fontSize: '11px' }} />
        </a>}
      </Col>
      <Col xs={24} md={12}>
        <SummaryField
          label="Total Proposal Versions"
          value={summary.totalVersions === 1 ? '1 Version' : `${summary.totalVersions} Versions`}
        />
        <SummaryField
          label="Total Views"
          value={summary.totalViews === 1 ? '1 view' : `${summary.totalViews} views`}
        />
        {summary.approvedUtc !== undefined && summary.approvedUtc !== null &&
          <SummaryField label="Approved" value={formatDate(summary.approvedUtc)} />}
      </Col>
    </Row>
  </Card>
}

export default ProposalSummaryCard
